<template>
  <div class="outro-2d" ref="outroContainer" v-show="showOutro">
    <div class="outro-frame frame-1"
         ref="outroFrame1"
         v-html="text1"
    ></div>

    <div class="outro-frame frame-2" ref="outroFrame2">
      <div class="part-1"
           ref="outroFrame2Part1"
           v-html="text2p1"
      ></div>
      <div class="part-2"
           ref="outroFrame2Part2"
           v-html="text2p2"
      ></div>
    </div>

    <div class="outro-frame frame-3 logo-frame" ref="outroFrame3">
      <div class="logo-centererer"><img src="/_/components/img/logo.svg" alt="Vimy logo"/></div>
    </div>
  </div>
</template>

<script>
import gsap               from "gsap";
import { Power1, Power2 } from "gsap/gsap-core";

import { OutroStore } from '@/store/index';

import BusEvent      from '../../../../shared/js/BusEvent';
import { translate } from '@/helpers/locale-helper';


/* tslint:disable */
/* eslint-disable */

export default {
  name : "Outro",

  data ()
  {
    return {
      showOutro : true,

    }
  },

  computed : {
    text1 ()
    {
      return translate( this.$i18n.locale, 'outro.text1' )
    },
    text2p1 ()
    {
      return translate( this.$i18n.locale, 'outro.text2p1' )
    },
    text2p2 ()
    {
      return translate( this.$i18n.locale, 'outro.text2p2' )
    },
  },

  mounted ()
  {
    this.bindLaunchOutro();
  },

  methods : {


    bindLaunchOutro ()
    {
      document.addEventListener( BusEvent.EVENTS.OUTRO_START_TEXT, this.animateOutro2d );
    },

    animateOutro2d ()
    {
      this.showOutro = true;

      const wantedEase = Power1.easeInOut;


      this.gsapTimeline = gsap.timeline()

        // reset the last frame
        .set( this.$refs.outroFrame1, { delay : 0, duration : 0, opacity : 0 } )
        .set( this.$refs.outroFrame2, { delay : 0, duration : 0, opacity : 0 } )
        .set( this.$refs.outroFrame2Part1, { delay : 0, duration : 0, opacity : 0 } )
        .set( this.$refs.outroFrame2Part2, { delay : 0, duration : 0, opacity : 0 } )
        .set( this.$refs.outroFrame3, { delay : 0, duration : 0, opacity : 0, left : '50%', top : '50%' } )


        // animation starts here
        // "Merci d'avoir parcouru..."
        .to( this.$refs.outroFrame1, { delay : 0, duration : 1, opacity : 1, ease : wantedEase } )
        .to( this.$refs.outroFrame1, { delay : 2.5, duration : 0.5, opacity : 0, ease : wantedEase } )


        // reveal the whole layer because we'll be animating the innards individually
        // "Depuis la nuit des temps..."
        // "... à nous de préserver ..."
        .set( this.$refs.outroFrame2, { delay : 0, duration : 0, opacity : 1 } )

        .to( this.$refs.outroFrame2Part1, { delay : 0, duration : 1, opacity : 1, ease : wantedEase } )
        .to( this.$refs.outroFrame2Part2, { delay : 1, duration : 1, opacity : 1, ease : wantedEase } )

        .to( this.$refs.outroFrame2, { delay : 5, duration : 1, opacity : 0, ease : wantedEase } )


        // .to( this.$refs.outroFrame3, { delay : 2, duration : 1, opacity : 1, ease : wantedEase } )
        // .to( this.$refs.outroFrame3, { delay : 2, duration : 2, top : 100, scale : 0.5, ease : Power2 } )

        .call( () =>
        {
          document.dispatchEvent( new BusEvent( BusEvent.EVENTS.OUTRO_2D_FINISHED ) );
        } )

    },

    resetOutro2s ()
    {
      this.showOutro = false;
    },
  },
}
</script>

<style lang="scss">
@import "./Outro.scss";
</style>
